import React from 'react';
import { Navigate } from 'react-router-dom';
import { useVolunteerAuth } from '../../hooks/useVolunteerAuth';

function ProtectedVolRoute({ children }) {
  const { firebaseUser, volunteer, volLoading } = useVolunteerAuth();

  // Admins logged in via the admin panel get full access to the volunteer portal
  const isAdmin = localStorage.getItem('adminAuth') === 'true';
  if (isAdmin) return children;

  if (volLoading || firebaseUser === undefined) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', color: '#64748b', fontSize: '15px' }}>
        Loading…
      </div>
    );
  }

  if (!firebaseUser) {
    return <Navigate to="/vol/login" replace />;
  }

  if (!volunteer) {
    return <Navigate to="/vol/login?notfound=1" replace />;
  }

  if (volunteer.approvalStatus !== 'approved') {
    return <Navigate to="/vol/pending" replace />;
  }

  return children;
}

export default ProtectedVolRoute;
